import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Feather } from "lucide-react";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(name, email, password);
      toast.success("Welcome to Humanly");
      const next = new URLSearchParams(loc.search).get("next");
      nav(next ? `/${next}` : "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <span className="w-8 h-8 rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] flex items-center justify-center"><Feather size={16} /></span>
          <span className="font-display text-xl">Humanly</span>
        </Link>
        <div className="surface p-8">
          <h1 className="font-display text-3xl mb-2">Create your account</h1>
          <p className="text-sm text-[hsl(var(--muted-foreground))] mb-6">Free forever plan — 1,500 words / month.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label-eyebrow block mb-2">Name</label>
              <input
                data-testid="signup-name"
                required
                value={name} onChange={(e) => setName(e.target.value)}
                className="w-full bg-white border border-[hsl(var(--border))] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--primary))]/30 focus:border-[hsl(var(--primary))]"
                placeholder="Your name"
              />
            </div>
            <div>
              <label className="label-eyebrow block mb-2">Email</label>
              <input
                data-testid="signup-email"
                type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white border border-[hsl(var(--border))] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--primary))]/30 focus:border-[hsl(var(--primary))]"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label className="label-eyebrow block mb-2">Password</label>
              <input
                data-testid="signup-password"
                type="password" required minLength={6}
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-white border border-[hsl(var(--border))] rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--primary))]/30 focus:border-[hsl(var(--primary))]"
                placeholder="At least 6 characters"
              />
            </div>
            <button
              data-testid="signup-submit"
              type="submit" disabled={loading}
              className="btn-primary w-full disabled:opacity-60"
            >
              {loading ? "Creating…" : "Create account"}
            </button>
          </form>
          <div className="mt-6 text-sm text-center text-[hsl(var(--muted-foreground))]">
            Already have one? <Link to="/login" className="link-underline text-[hsl(var(--primary))] font-semibold">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
